import React, { Component } from 'react';

class FieldValue extends Component {
    handleChange = (event) => {
        let value = event.target.value;
        if (event.target.multiple) {
            value = [];
            for (let i = 0; i < event.target.options.length; i++) {
                if (event.target.options[i].selected) {
                    value.push(event.target.options[i].value);
                }
            }
        }

        this.props.onChange(this.props.id, value);
    }

    render() {
        let value = this.props.value;
        let input = null;

        if (this.props.edit) {
            if (this.props.options) {
                input = <select defaultValue={this.props.value} onChange={this.handleChange}><option></option>{this.props.options.map(v => <option key={v} value={v}>{v}</option>)}</select>;
            } else if (this.props.map) {
                input = <select defaultValue={this.props.value} multiple={this.props.multiple} onChange={this.handleChange}>{this.props.multiple ? null : <option></option>}{this.props.map.map(e => <option key={e.key} value={e.key}>{e.value}</option>)}</select>;
            } else {
                input = <input type="text" defaultValue={this.props.value} onChange={this.handleChange} maxLength={this.props.multiple ? 1000000 : 100} />;
            }
        } else {
            if (this.props.map && this.props.multiple) {
                const entries = this.props.map.filter(e => (this.props.value || []).includes(e.key)).map(e => e.value);
                value = entries.length ? entries.join(', ') : this.props.map.find(e => e.key === '').value;
            } else if (this.props.map) {
                const entry = this.props.map.find(e => e.key === this.props.value) || this.props.map.find(e => e.key === '');
                value = entry.value;
            } else if (this.props.multiple) {
                value = this.props.value && this.props.value.join(', ');
            }

            if (value === undefined) value = <i>&mdash; Blank &mdash;</i>;
        }

        return this.props.edit ? input : value;
    }
}

export default FieldValue;